export default __webpack_public_path__ + "static/media/TT_logo.bf791e88.svg";